import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../components/Select/SelectAsyncRPC.js";
import { useRegionContext } from "../../Regions/contexts/RegionContext.js";
import "react";
import { Image } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { RPCs } from "@therms/rpc-gateway";
//#region src/modules/Records/shared/SelectRecord.tsx
var Base = ({ record }) => {
	if (!record) return null;
	const { primaryImageUrl, title, type } = record;
	return /* @__PURE__ */ jsxs("div", {
		className: "space-x-sm my-auto flex items-center text-sm",
		children: [/* @__PURE__ */ jsx("div", {
			className: "shrink-0",
			children: /* @__PURE__ */ jsx(Image, {
				src: primaryImageUrl,
				className: "max-h-xl"
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "truncate",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-color-subtle truncate font-medium capitalize",
				children: type
			}), /* @__PURE__ */ jsx("div", {
				className: "truncate",
				children: title
			})]
		})]
	});
};
var SelectRecordRenderComponents = {
	ListItem: (recordOption) => /* @__PURE__ */ jsx(Base, { record: recordOption }),
	SelectedMulti: (record, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
		onRemove,
		children: /* @__PURE__ */ jsx("div", {
			className: "ml-xxs mr-sm max-w-full",
			children: /* @__PURE__ */ jsx(Base, { record })
		})
	}),
	SelectedSingle: (record) => /* @__PURE__ */ jsx(Base, { record })
};
var responseOptionsExtractor = (data) => data?.records;
var SelectRecord = ({ idFilter, limit = 10, multi, typeFilter, value, ...atalayaSelectProps }) => {
	const regionCtx = useRegionContext();
	return /* @__PURE__ */ jsx(SelectAsyncRPC, {
		RenderListItem: SelectRecordRenderComponents.ListItem,
		RenderSelectedMulti: SelectRecordRenderComponents.SelectedMulti,
		RenderSelectedSingle: SelectRecordRenderComponents.SelectedSingle,
		args: {
			idFilter,
			regionIds: regionCtx ? [regionCtx?.regionId] : void 0,
			typeFilter
		},
		idProp: "id",
		limit,
		multi,
		optionLabelExtractor: ({ title }) => title,
		optionValueExtractor: ({ id }) => id,
		request: RPCs.Records.GetRecordsList.v1,
		requestFilterProp: "idFilter",
		responseOptionsExtractor,
		value,
		...atalayaSelectProps
	});
};
//#endregion
export { SelectRecord, SelectRecordRenderComponents };

//# sourceMappingURL=SelectRecord.js.map